import Vue from "vue";
import VueRouter from "vue-router";
import EventBus from "../eventBus";
import store from "../store/index";

Vue.use(VueRouter);

async function CheckManager(to, from, next) {
  var iRet = await store.state.iGetCustomInfo(store.state.CustomInfo.SiteId, from.name)

  if (iRet == 0) {
    for (let i = 0; i < routes.length; i ++){
      if (routes[i].name == to.name){


        //TEST CODE
        // store.state.CustomInfo.Manager = "M";
        // console.log("mama", store.state.CustomInfo.Manager)
        

        if (!routes[i].bChekManager) {
          if (store.state.CustomInfo.Manager == "M" || store.state.CustomInfo.Manager == "S") {
            next();
            return
          } else {
            EventBus.$emit("onShowMsgBox","접근권한이 없습니다.","협력업체 관리자만 접근 가능한 페이지 입니다.");
            return
          }
        } else {
          next();
          return
        }
      }
    }

    next();
  } else {
    if (from.name != null && iRet == -1) {
      EventBus.$emit("onTokenExpired");
    } else if (from.name != null && iRet == -2) {
      next("/Login");
      EventBus.$emit("onShowMsgBox", "로그인에 실패하였습니다.", "사용할 수 없는 아이디 입니다. 회원가입 후 이용 바랍니다.");
    } else if (iRet == 1) {
      EventBus.$emit("onChangeCorpInfo");
    } else {
      next("/Login");
    }
  }
  EventBus.$emit("onScrollIdView",from.name);
}

const rejectCustomLogin = (to, from, next) => {
  if (store.state.isLogin === true) {
    next("/");
  } else {
    next();
  }
  EventBus.$emit("onScrollIdView","");
};

//-----------------------------------------------------------------------------//
//페이지 추가시, DB의 programinfo table(CRUD)에 추가 필요

const routes = [
  {
    path: "/Login",
    name: "DashBoard",
    caption: "로그인",
    bChekManager : true,
    beforeEnter: rejectCustomLogin,
    // component: () => import("../views/DashBoard1.vue")
    component: () => import("../views/DashBoard.vue")
  },
  {
    path: "/",
    name: "MainBoard",
    caption: "홈",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/MainBoard.vue")
  },
  {
    path: "/ChangeCustomInfo",
    name: "ChangeCustomInfo",
    caption: "회원정보수정",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/ChangeCustomInfo.vue")
  },
  {
    path: "/ChangeCompanyInfo",
    name: "ChangeCompanyInfo",
    caption: "업체정보 정정신청",
    bChekManager : false,
    beforeEnter: CheckManager,
    component: () => import("../views/ChangeCompanyInfo.vue")
  },
  {
    path: "/Penalty",
    name: "Penalty",
    caption: "보안규정 위반내역",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/Penalty.vue")
  },
  {
    path: "/MoveCompany",
    name: "MoveCompany",
    caption: "소속업체 변경 신청",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/MoveCompany.vue")
  },
  {
    path: "/ChangeCorpManger",
    name: "ChangeCorpManger",
    caption: "협력업체 관리자 신청",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/ChangeCorpManger.vue")
  },
  {
    path: "/PledgeStatus",
    name: "PledgeStatus",
    caption: "서약 현황",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/PledgeStatus.vue")
  },
  {
    path: "/SecurityEducationStatus",
    name: "SecurityEducationStatus",
    caption: "보안 교육 현황",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/SecurityEducationStatus.vue")
  },
  {
    path: "/VisitGuide",
    name: "VisitGuide",
    caption: "방문예약 신청안내",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/VisitGuide.vue")
  },
  {
    path: "/VisitReq",
    name: "VisitReq",
    caption: "방문예약",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/VisitReq.vue")
  },
  {
    path: "/VisitStatus",
    name: "VisitStatus",
    caption: "방문예약 신청현황",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/VisitStatus.vue")
  },
  {
    path: "/PassGuide",
    name: "PassGuide",
    caption: "방문증 분실 신고 안내",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/PassGuide.vue")
  },
  {
    path: "/PassReq",
    name: "PassReq",
    caption: "방문증 분실 신고",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/PassReq.vue")
  },
  {
    path: "/PassStatus",
    name: "PassStatus",
    caption: "방문증 분실 신고 현황",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/PassStatus.vue")
  },
  {
    path: "/CorCarryGuide",
    name: "CorCarryGuide",
    caption: "업체물품 반입 신청 안내",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/CorCarryGuide.vue")
  },
  {
    path: "/CorCarryReq",
    name: "CorCarryReq",
    caption: "업체물품 반입 신청",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/CorCarryReq.vue")
  },
  {
    path: "/CorCarryStatus",
    name: "CorCarryStatus",
    caption: "업체물품 반입 신청 현황",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/CorCarryStatus.vue")
  },
  {
    path: "/PictureGuide",
    name: "PictureGuide",
    caption: "사진촬영 허가 신청 안내",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/PictureGuide.vue")
  },
  {
    path: "/PictureReq",
    name: "PictureReq",
    caption: "사진촬영 허가 신청",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/PictureReq.vue")
  },
  {
    path: "/PictureStatus",
    name: "PictureStatus",
    caption: "사진촬영 허가 신청 현황",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/PictureStatus.vue")
  },
  {
    path: "/CameraGuide",
    name: "CameraGuide",
    caption: "카메라 대여 신청 안내",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/CameraGuide.vue")
  },
  {
    path: "/CameraReq",
    name: "CameraReq",
    caption: "카메라 대여 신청",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/CameraReq.vue")
  },
  {
    path: "/CameraStatus",
    name: "CameraStatus",
    caption: "카메라 대여 신청 현황",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/CameraStatus.vue")
  },
  {
    path: "/NoticeBoard",
    name: "NoticeBoard",
    caption: "공지사항",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/NoticeBoard.vue")
  },
  {
    path: "/FAQ",
    name: "FAQ",
    caption: "FAQ",
    bChekManager : true,
    beforeEnter: CheckManager,
    component: () => import("../views/FAQ.vue")
  },
  {
    path: "/Security",
    name: "Security",
    caption: "보안준수사항 안내",
    bChekManager : true,
    beforeEnter: CheckManager,
    // component: () => import("../views/SecStudy.vue")
    component: () => import("../views/Security.vue")
  },
];

const router = new VueRouter({
  // mode: "history",                    //기본설정은 hash모드임 (URL에 #포함. URL변경시 페이지가 다시 로드되지 않음.)
  base: process.env.BASE_URL,
  linkActiveClass: 'is-active',          //전역에 동일하게 CSS를 적용
  routes
});

// welcome.sk-materials.com에서 SKST 접근 시 로그아웃 + 초기화 후 사이트 선택 화면으로
router.beforeEach((to, from, next) => {
  if (window.location.hostname === "welcome.sk-materials.com") {
    const siteId = store.state.CustomInfo?.SiteId || localStorage.getItem("SiteId");
    if (siteId === "SKST") {
      localStorage.setItem("SiteId", "");
      store.dispatch("logout");
      store.state.CustomInfo.SiteId = "";
      next("/Login");
      return;
    }
  }
  next();
});

export default router;